/*
 * Lemonade Training Oy, copy rights, all right reserved.
 * The signed-in user's own gym zone in the three-state shape the zone hooks take.
 * A failed read reads as "no zone" in `zone`; `error` tells it apart from a gym
 * that simply has none.
 */
import { useBoxSettings } from "./useBoxSettings";

export interface OwnGymZone {
  zone: string | null | undefined;
  error: Error | null;
}

/** `enabled: false` reads nothing and reports no zone. */
export function useOwnGymZone(enabled = true): OwnGymZone {
  const { zone, error } = useBoxSettings(enabled ? undefined : null);
  return { zone, error };
}
